const STD_STICKER_SIZE = 3;
const MIN_DIMENSION_SIZE = 1;

const defaultStickerDimensions = (originalWidth, originalHeight, aspectRatio) => {
  let width = originalWidth;
  let height = originalHeight;

  if (width >= height) {
    width = STD_STICKER_SIZE;
    height = width / aspectRatio;
  } else {
    height = STD_STICKER_SIZE;
    width = height * aspectRatio;
  }

  return { width, height };
};

const enforceMinDimensions = (originalWidth, originalHeight, aspectRatio) => {
  let width = originalWidth;
  let height = originalHeight;

  if (width < MIN_DIMENSION_SIZE) {
    width = MIN_DIMENSION_SIZE;
    height = width / aspectRatio;
  } else if (height < MIN_DIMENSION_SIZE) {
    height = MIN_DIMENSION_SIZE;
    width = height * aspectRatio;
  }

  return { width, height };
};

// eslint-disable-next-line import/prefer-default-export
export const getStickerDimensions = (originalWidth, originalHeight, skipDefaultCheck = false) => {
  const aspectRatio = originalWidth / originalHeight;
  let width = parseFloat(originalWidth);
  let height = parseFloat(originalHeight);

  if (!skipDefaultCheck) {
    ({ width, height } = defaultStickerDimensions(width, height, aspectRatio));
  }

  ({ width, height } = enforceMinDimensions(width, height, aspectRatio));

  return {
    width: width.toFixed(2),
    height: height.toFixed(2)
  };
};
